module.exports = __webpack_public_path__ + "static/media/spinner-rainbow.711ababa.svg";